module.exports = __webpack_public_path__ + "img/row-grey-small.d2d1bc43.svg";